var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Auth } from 'aws-amplify';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { getItem as getLocalStorageItem } from '../../../helpers/localStorage';
import { AuthService, NotificationService, UserService, } from '../../../services';
import { USER_INFO, userInfoError, userInfoSuccess, setHolder, setPlans, setOrganization, setOrganizations, setTotalNotifications, setUser, logoutUser, } from '../../actions';
// Get User Info
var getUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token, userInfo_1, _a, userInfo_2, userMoreInfo;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                token = getLocalStorageItem('token');
                if (!token) return [3 /*break*/, 2];
                return [4 /*yield*/, AuthService.getInfo()];
            case 1:
                userInfo_1 = _b.sent();
                return [2 /*return*/, userInfo_1];
            case 2: return [4 /*yield*/, Promise.all([
                    Auth.currentUserInfo(),
                    AuthService.getInfo(),
                ])];
            case 3:
                _a = _b.sent(), userInfo_2 = _a[0], userMoreInfo = _a[1];
                return [2 /*return*/, {
                        id: userMoreInfo.id,
                        firstName: userMoreInfo.firstName,
                        lastName: userMoreInfo.lastName,
                        email: userInfo_2 === null || userInfo_2 === void 0 ? void 0 : userInfo_2.attributes.email,
                        picture: userInfo_2 === null || userInfo_2 === void 0 ? void 0 : userInfo_2.attributes.picture,
                    }];
        }
    });
}); };
// Get Organization User
var getOrganizationsAsync = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, UserService.getOrganizations()];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
// Get Holder User
var getHoldersAsync = function (organizationId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, UserService.getHolders(organizationId)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
// Get User Plans
var getPlansAsync = function (holderId, organizationId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, UserService.getPlans(holderId, organizationId)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
// Get total notifications
var getTotalNotiticationsAsync = function (organizationId) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, NotificationService.getTotal(organizationId)];
        case 1: return [2 /*return*/, _a.sent()];
    }
}); }); };
function totalNotifications(organizationId) {
    var notifications, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                return [4 /*yield*/, call(getTotalNotiticationsAsync, organizationId)];
            case 1:
                notifications = _b.sent();
                return [4 /*yield*/, put(setTotalNotifications((notifications === null || notifications === void 0 ? void 0 : notifications.total) || null))];
            case 2:
                _b.sent();
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
function userInfo() {
    var _a, userInfo_3, organizations, organization, settings, profile, holderUser, holder, plans, error_1;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 15, , 17]);
                return [4 /*yield*/, all([
                        call(getUserInfo),
                        call(getOrganizationsAsync),
                    ])];
            case 1:
                _a = _f.sent(), userInfo_3 = _a[0], organizations = _a[1];
                if (!((organizations === null || organizations === void 0 ? void 0 : organizations.length) === 0)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(logoutUser('Acesso indisponível! Entre em contato via whatsapp pelo número (21) 97898-0378 ou email: faleconosco@tratum.com.br'))];
            case 2:
                _f.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, put(setUser(userInfo_3))];
            case 4:
                _f.sent();
                organization = void 0;
                if (!localStorage.organization) {
                    organization = organizations[0];
                    localStorage.setItem('organization', JSON.stringify({
                        id: organization.id,
                        name: organization.name,
                    }));
                }
                else {
                    organization = organizations.find(function (item) { return item.id === JSON.parse(localStorage.organization).id; });
                    if (!organization) {
                        organization = organizations[0];
                    }
                }
                settings = {
                    notifications: {
                        changeProcess: (_b = organization.notification) === null || _b === void 0 ? void 0 : _b.notifyChangeProcess,
                        newProcess: (_c = organization.notification) === null || _c === void 0 ? void 0 : _c.notifyNewProcess,
                    },
                };
                profile = organization.profile;
                return [4 /*yield*/, put(setOrganization({
                        id: organization.id,
                        name: organization.name,
                        type: organization.typeOrganization,
                        profile: profile,
                        settings: settings,
                        oldAdmin: organization.bubbleAdmin,
                        roles: organization.roles,
                    }))];
            case 5:
                _f.sent();
                return [4 /*yield*/, put(setOrganizations(organizations))];
            case 6:
                _f.sent();
                return [4 /*yield*/, all([
                        call(getHoldersAsync, organization.id),
                        fork(totalNotifications, organization.id),
                    ])];
            case 7:
                holderUser = (_f.sent())[0];
                holder = (_e = (_d = holderUser === null || holderUser === void 0 ? void 0 : holderUser.result) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.holder;
                if (!holder) return [3 /*break*/, 11];
                return [4 /*yield*/, put(setHolder({ id: holder.holderId, name: holder.holderName }))];
            case 8:
                _f.sent();
                return [4 /*yield*/, call(getPlansAsync, holder.holderId, organization.id)];
            case 9:
                plans = _f.sent();
                return [4 /*yield*/, put(setPlans(plans))];
            case 10:
                _f.sent();
                return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, put(setHolder(null))];
            case 12:
                _f.sent();
                _f.label = 13;
            case 13: return [4 /*yield*/, put(userInfoSuccess())];
            case 14:
                _f.sent();
                return [3 /*break*/, 17];
            case 15:
                error_1 = _f.sent();
                return [4 /*yield*/, put(userInfoError(error_1.message))];
            case 16:
                _f.sent();
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
export function watchUserInfo() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(USER_INFO, userInfo)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
